import * as React from 'react'

function SvgIllustrationNoChart(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg viewBox="0 0 160 160" xmlns="http://www.w3.org/2000/svg" ref={svgRef} {...props}>
      <defs>
        <linearGradient x1="50%" y1="98.028%" x2="50%" y2="0%" id="illustration-no-chart_svg__a">
          <stop stopColor="#D6DAE1" stopOpacity={0} offset="0%" />
          <stop stopColor="#D6DAE1" offset="100%" />
        </linearGradient>
      </defs>
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h160v160H0z" />
        <g transform="translate(9.838 8.88)">
          <path
            d="M0 70.402v.003C0 109.283 31.52 140.8 70.4 140.8c38.88 0 70.4-31.517 70.4-70.395v-.01C140.8 31.517 109.28 0 70.4 0 31.52 0 0 31.517 0 70.395v.007z"
            fill="#F5F5F5"
            fillRule="nonzero"
          />
          <path
            d="M132.669 32.443a3.52 3.52 0 100 7.04 3.52 3.52 0 000-7.04zm0 .64a2.88 2.88 0 110 5.76 2.88 2.88 0 010-5.76z"
            fill="#18263C"
            fillRule="nonzero"
          />
          <circle fill="#126BFB" fillRule="nonzero" cx={4.669} cy={96.763} r={3.2} />
          <path
            d="M11.496 70.054c0 32.4 26.266 58.667 58.666 58.667 32.401 0 58.667-26.266 58.667-58.667 0-32.4-26.266-58.667-58.667-58.667-32.4 0-58.666 26.266-58.666 58.667z"
            fill="#DEDEDE"
            fillRule="nonzero"
          />
          <path
            d="M117.88 133.402H22.92a2.981 2.981 0 01-2.98-2.981V10.383A2.981 2.981 0 0122.92 7.4h94.96a2.981 2.981 0 012.982 2.982V130.42a2.981 2.981 0 01-2.982 2.981z"
            fill="#FFF"
            fillRule="nonzero"
          />
          <path
            d="M117.88 7.081H22.92l-.19.006a3.303 3.303 0 00-3.11 3.296V130.42l.005.191a3.303 3.303 0 003.296 3.11h94.96a3.301 3.301 0 003.3-3.301V10.383l-.005-.191a3.303 3.303 0 00-3.296-3.11zm-94.95.64h94.95c1.41 0 2.573 1.1 2.657 2.5l.005.171v120.029a2.661 2.661 0 01-2.662 2.661H22.92a2.662 2.662 0 01-2.656-2.499l-.005-.172V10.383c0-1.41 1.1-2.573 2.5-2.657l.171-.005z"
            fill="#222"
            fillRule="nonzero"
          />
          <path fill="#393939" d="M38.174 60.79h-1v23.58h1z" />
          <path
            fill="#126BFB"
            d="M39.622 62.026h62.316v2.133H39.622zM39.622 68.35h37.053v2.134H39.622zM39.622 74.676h13.474v2.133H39.622zM39.622 81.002h3.368v2.133h-3.368z"
          />
          <path
            fill="url(#illustration-no-chart_svg__a)"
            fillRule="nonzero"
            d="M40.16 31.403L55.246 41.72l15.083-10.317 15.086 3.975 15.225-7.95v20.75H40.16z"
          />
          <path
            fill="#393939"
            fillRule="nonzero"
            d="M100.443 27.049l.395.756-15.373 8.027-14.99-3.968-15.23 10.373L39.92 31.755l.482-.705 14.845 10.153L70.318 30.94l15.045 3.982z"
          />
          <path fill="#E8EDEB" fillRule="nonzero" d="M61.53 15.57h17.736v2.732H61.529z" />
          <path
            d="M37.096 31.634v.001a3.18 3.18 0 006.358 0v-.002a3.18 3.18 0 00-6.358 0v.001z"
            fill="#7E8B9F"
            fillRule="nonzero"
          />
          <path
            d="M38.203 31.403a1.957 1.957 0 003.914 0 1.957 1.957 0 00-3.914 0z"
            fill="#FFF"
            fillRule="nonzero"
          />
          <path
            d="M43.444 98.707a9.435 9.435 0 000 18.87h.426l-.001-9.009h9.01v-.426a9.435 9.435 0 00-9.435-9.435zm.268.857a8.583 8.583 0 018.298 8.045l.004.106h-8.997l-.001 8.997-.105-.004a8.583 8.583 0 01.533-17.148l.268.004z"
            fill="#393939"
            fillRule="nonzero"
          />
          <path
            d="M53 109.277a8.423 8.423 0 01-8.421 8.421v-8.42h8.42z"
            fill="#D6DAE1"
            fillRule="nonzero"
          />
          <path
            d="M70.823 107.112v-8.406h-.426a9.436 9.436 0 106.674 2.763l-.302-.302-5.946 5.945zm-.854-7.541l.001 9.6 6.79-6.79.148.166a8.582 8.582 0 11-7.043-2.97l.104-.006z"
            fill="#393939"
            fillRule="nonzero"
          />
          <path
            d="M76.077 100.922l-4.88 4.88v-6.905c1.831 0 3.587.728 4.88 2.025z"
            fill="#D6DAE1"
            fillRule="nonzero"
          />
          <path
            d="M97.783 117.577v-18.87h-.426c-5.212 0-9.436 4.224-9.435 9.435a9.435 9.435 0 009.435 9.435h.426zm-.854-18.006v17.141l-.105-.004a8.583 8.583 0 01-8.048-8.566c-.001-4.56 3.556-8.29 8.048-8.566l.105-.005z"
            fill="#393939"
            fillRule="nonzero"
          />
          <path
            d="M107.434 108.144c0 4.969-4.035 9.004-9.014 9.004V99.13a9.013 9.013 0 019.014 9.014z"
            fill="#D6DAE1"
            fillRule="nonzero"
          />
          <path
            d="M52.066 41.735a3.18 3.18 0 006.358 0v-.002a3.18 3.18 0 00-6.358 0v.002z"
            fill="#7E8B9F"
            fillRule="nonzero"
          />
          <path
            d="M53.288 41.735a1.957 1.957 0 003.913 0 1.957 1.957 0 00-3.913 0z"
            fill="#FFF"
            fillRule="nonzero"
          />
          <path
            d="M67.22 31.403a3.18 3.18 0 006.36 0v-.001a3.18 3.18 0 00-6.36 0z"
            fill="#126BFB"
            fillRule="nonzero"
          />
          <path
            d="M68.443 31.403a1.957 1.957 0 003.914 0 1.957 1.957 0 00-3.914 0z"
            fill="#FFF"
            fillRule="nonzero"
          />
          <path
            d="M82.235 35.378a3.18 3.18 0 006.358 0 3.18 3.18 0 00-6.358 0z"
            fill="#7E8B9F"
            fillRule="nonzero"
          />
          <path
            d="M85.414 37.334a1.957 1.957 0 100-3.913 1.957 1.957 0 000 3.913z"
            fill="#FFF"
            fillRule="nonzero"
          />
          <path
            d="M97.46 27.427v.001a3.18 3.18 0 006.36 0v-.002a3.18 3.18 0 00-6.36 0v.001z"
            fill="#7E8B9F"
            fillRule="nonzero"
          />
          <path
            d="M98.683 27.427a1.957 1.957 0 003.914 0 1.957 1.957 0 00-3.914 0z"
            fill="#FFF"
            fillRule="nonzero"
          />
        </g>
      </g>
    </svg>
  )
}

const ForwardRef = React.forwardRef(SvgIllustrationNoChart)
const MemoForwardRef = React.memo(ForwardRef)
export default MemoForwardRef
